'use client';

import Link from 'next/link';

import { useAuth } from '@flipster/features/src/shared/auth/state';
import { center } from '@flipster/styled-system/patterns';
import DocumentHistoryIcon from '@flipster/ui/assets/svgs/document-history.svg';

interface Props {
  /** 현재 선택된 통화 탭. `'total'`(전체)이면 통화 필터 없이 연다. */
  tab: string;
}

export const HistoryLink = ({ tab }: Props) => {
  const { isCookieLoggedIn } = useAuth();

  // Earn 히스토리는 통화를 `?currency=`로 받는다. (history-page/transaction/earn)
  const href =
    tab === 'total' ? '/history/transaction/earn' : `/history/transaction/earn?currency=${encodeURIComponent(tab)}`;

  return (
    <Link
      className={center({ color: 'content.default.level-5' })}
      href={href}
      prefetch={isCookieLoggedIn}
      target='_blank'
    >
      <DocumentHistoryIcon />
    </Link>
  );
};
